import React from "react";
import PropTypes from "prop-types";
import Composer from "apps/messenger/components/MainWindow/Composer";
import Toolbar from "apps/messenger/components/MainWindow/Toolbar";
import { WINDOW_STATE } from "apps/messenger/util/consts";
import _str from "shared/util/_str";

import Banners from "apps/messenger/components/MainWindow/Banners";
import ViewContainer from "apps/messenger/components/Connections/shared/ViewContainer";
import Header from "apps/messenger/components/Connections/shared/Header";
import UserThumb from "shared/components/UserThumb";

import "apps/messenger/components/Connections/Prematch/BaseIntro.scss";

function BaseIntro({
	onClose,
	header,
	subtitle,
	targetUser,
	children,
	onMessageEdit,
	sendMessage,
	draft,
	error,
}) {
	const sendDisabled = !draft.trim().length;

	return (
		<div className="prematch-intro-edit-view-scaffold">
			<ViewContainer onClose={onClose}>
				<div className="prematch-intro-edit-view-scaffold-thumb">
					<div className="prematch-intro-edit-view-scaffold-thumb-content">
						<UserThumb
							username={targetUser.userinfo.displayname}
							thumbs={targetUser.thumbs}
							size="225x225"
							shape={UserThumb.displayTypes.Round}
						/>
					</div>
				</div>
				<Header>{header}</Header>
				{subtitle &&
					<Header>{subtitle}</Header>
				}
				<div className="prematch-intro-edit-view-scaffold-content">
					{children}
				</div>
			</ViewContainer>
			<Banners
				name={targetUser.username}
				error={error}
			/>
			<Composer
				userid={targetUser.userid}
				state={WINDOW_STATE.Open}
				onTextChange={onMessageEdit}
				sendDisabled={sendDisabled}
				sendMessage={sendMessage}
				text={draft}
				focusTimeout={300}
			/>
			<Toolbar
				userid={targetUser.userid}
				sendDisabled={sendDisabled}
				sendMessage={sendMessage}
				text={_str("Send")}
			/>
		</div>
	);
}

BaseIntro.propTypes = {
	onClose: PropTypes.func.isRequired,
	header: PropTypes.string.isRequired,
	subtitle: PropTypes.string,
	children: PropTypes.node.isRequired,
	targetUser: PropTypes.object.isRequired,
	onMessageEdit: PropTypes.func.isRequired,
	sendMessage: PropTypes.func.isRequired,
	draft: PropTypes.string,
	error: PropTypes.string,
};

BaseIntro.defaultProps = {
	subtitle: null,
	draft: "",
	error: null,
};

export default BaseIntro;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/Connections/Prematch/BaseIntro.jsx